import { render, staticRenderFns } from "./UiRegistration.vue?vue&type=template&id=3b7fabab&lang=pug&"
import script from "./UiRegistration.vue?vue&type=script&lang=js&"
export * from "./UiRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports